import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'main' }
    }, {
      path: '/main',
      name: 'main'
    }, {
      path: '/customIndex/:type/:state?/:dataId?',
      name: 'customIndex',
      component: (resolve) => {
        require(['../pages/customIndex.vue'], resolve)
      }
    }, {
      path: '/customEdit/:type/:id?',
      name: 'customEdit',
      component: (resolve) => {
        require(['../pages/customEdit.vue'], resolve)
      }
    }, {
      path: '/orderDetail/:id/:state?',
      name: 'orderDetail',
      component: (resolve) => {
        require(['../pages/orderDetail.vue'], resolve)
      }
    }, {
      path: '/bountyDetail/:id/:state/:dataId',
      name: 'bountyDetail',
      component: (resolve) => {
        require(['../pages/bountyDetail.vue'], resolve)
      }
    }, {
      path: '/bountyOrderDetail/:id/:state/:dataId',
      name: 'bountyOrderDetail',
      component: (resolve) => {
        require(['../pages/bountyOrderDetail.vue'], resolve)
      }
    }, {
      path: '/kitDetail/:id/:state?',
      name: 'kitDetail',
      component: (resolve) => {
        require(['../pages/kitDetail.vue'], resolve)
      }
    }, {
      path: '*',
      redirect: { name: 'main' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js